export enum VehicleStatus {
  draft = 'draft',
  verification = 'verification',
  confirmed = 'confirmed',
  disabled = 'disabled',
}
